let config = {
  app_mode: process.env.REACT_APP_APP_MODE,
  jwt_store_key: "hos_admin_jwt_secret_storage",
  sizeLimit: 5,
  azure_object_url: process.env.REACT_APP_AZURE_OBJECT_URL,
  allowed_extensions: ["image/jpeg", "image/png", "image/svg+xml", "image/svg"],
  joiOptions: {
    abortEarly: false,
    allowUnknown: true,
    errors: {
      wrap: {
        label: "",
      },
    },
  },
};

export default config;
